import { useContext, useState } from "react";
import { HideLoder, ShowLoder } from "../../JS/Common";
import { useMsal } from '@azure/msal-react';
import { ApiPostCallAuthKey } from "../../JS/Connector";
import AlertsComp from "../../Components/AlertsComp";
import { setHelpTicketDetails, setSupportTicketDetails } from "../../Store/Slices/authSlice";
import { useDispatch } from "react-redux";
import useConfig from "../../Hooks/useConfig";

export function MicrosoftLoginForSupportTicket(props) {
    const {third_party_page_logo} = useConfig();
    const pathname = window.location.pathname;
    const pathArray = pathname.split('/');
    const schoolnumber = pathArray[2];
    const [Alerts, setAlerts] = useState("");
    const [loading, setLoading] = useState(false);
    const [AlertColor, setAlertColor] = useState('');
    const [alertsMsg, setAlertsMsg] = useState('');
    const [hasRegistered, setHasRegistered] = useState(false);
    const { instance } = useMsal();
    const reduxDispatch = useDispatch();
    const handleLoginSuccess = async () => {
        if (hasRegistered) return;
        const loginResponse = await instance.loginPopup({
            scopes: ["user.read", "email", "openid", "profile"]
        });
        if (loginResponse) {
            var rawForShow = JSON.stringify({
                name: loginResponse.account.name,
                email: loginResponse.account.username,
                ssoId: loginResponse.accessToken,
            });
            var raw = JSON.stringify({
                schoolNumber: schoolnumber,
                googleId: null,
                ssoId: loginResponse.accessToken,
                flag: 2,
            });
            await ApiPostCallAuthKey("/auth/sso-validation", raw).then((result) => {
                setHasRegistered(true);
                if (result == undefined || result == "") {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={'Login Failed!'} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                    }, 3000);
                } else {
                    const responseRs = JSON.parse(result);
                    setLoading(false)
                    if (responseRs.status == "success") {
                        const expires = 1;
                        reduxDispatch(setSupportTicketDetails(rawForShow));
                        setAlertColor('green')
                        setAlertsMsg(responseRs.msg)
                        setTimeout(function () {
                            props.setLoginFlag(0)
                        }, 2500);
                    }
                    else {
                        setAlertColor('red')
                        setAlertsMsg(responseRs.msg);
                        setHasRegistered(false);
                    }
                }
            });
        }
    };
    const handleHelpdeskLogin = async () => {
        if (hasRegistered) return;
        const loginResponse = await instance.loginPopup({
            scopes: ["user.read", "email", "openid", "profile"]
        });
        if (loginResponse) {
            var rawForShow = JSON.stringify({
                name: loginResponse.account.name,
                email: loginResponse.account.username,
                ssoId: loginResponse.accessToken,
            });
            var raw = JSON.stringify({
                schoolNumber: schoolnumber,
                googleId: null,
                ssoId: loginResponse.accessToken,
                flag: 2,
            });
            await ApiPostCallAuthKey("/auth/helpdesk-validation", raw).then((result) => {
                setHasRegistered(true);
                if (result == undefined || result == "") {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={'Login Failed!'} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                    }, 3000);
                } else {
                    const responseRs = JSON.parse(result);
                    setLoading(false)
                    if (responseRs.status == "success") {
                        const expires = 1;
                        reduxDispatch(setHelpTicketDetails(rawForShow));
                        setAlertColor('green')
                        setAlertsMsg(responseRs.msg)
                        setTimeout(function () {
                            props.setLoginFlag(0)
                        }, 2500);
                    }
                    else {
                        setAlertColor('red')
                        setAlertsMsg(responseRs.msg)
                        setHasRegistered(false);
                    }
                }
            });
        }
    };
    return (
        <>
            {loading ? <ShowLoder /> : <HideLoder />}
            {Alerts}
            <div className="card mx-auto">
                <div className="p-4 row">
                    <div className="col-12 text-center">
                        <div style={{ color: `${AlertColor}` }} className="font-16" >{alertsMsg}</div>
                    </div>
                    <div className="my-4">
                        {third_party_page_logo ?
                            <img src={third_party_page_logo} className="img-fluid" alt="Logo" />
                            :
                            <img src="/images/LoginLogo.png" className="img-fluid" alt="Logo" />
                        }
                    </div>
                    <div className="fw-600">
                        {props.flag == "supportticket" ?
                            <label>To create a support ticket, please sign in with microsoft first.</label>
                            :
                            <label>To create a Help Desk, please sign in with microsoft first.</label>
                        }
                    </div>
                    <div className="col-md-8 offset-md-2 text-center mt-4">
                        <div onClick={props.flag == "supportticket" ? handleLoginSuccess : handleHelpdeskLogin} style={{ padding: '10px 75px 10px 75px', fontSize: '13px', border: '1px solid #e2e3e4', borderRadius: '16px', backgroundColor: '#f9fafb', fontFamily: '"Poppins", sans-serif', cursor: 'pointer' }}>
                            <img src="/images/MicrosoftBtn.svg" alt="Microsoft" className="img-fluid pe-3" />
                            <span>Sign in with Microsoft</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
